import { useState } from "react";
import { Link } from "react-router-dom";
import VideoCard from "@/components/feature/VideoCard";
import { allVideos, sortVideos } from "@/lib/videoData";

const tabs = [
  { key: "all", label: "全部" },
  { key: "movie", label: "电影" },
  { key: "tv", label: "电视剧" },
  { key: "variety", label: "综艺" },
];

export default function LatestSection() {
  const [tab, setTab] = useState("all");

  const list = sortVideos(
    tab === "all" ? allVideos : allVideos.filter((item) => item.category === tab),
    "latest",
  ).slice(0, 6);

  return (
    <section className="mx-auto mt-10 w-full max-w-[1360px] px-4 md:mt-14 md:px-8">
      <div className="mb-5 flex flex-wrap items-end justify-between gap-4">
        <div className="flex items-center gap-3">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-50 text-primary-700">
            <i className="ri-calendar-check-line text-lg" />
          </span>
          <div>
            <h2 className="font-heading text-xl font-bold tracking-tight text-foreground-950 md:text-[22px]">
              最新更新
            </h2>
            <p className="mt-1 text-xs text-foreground-600 md:text-[13px]">
              按上线时间倒序排列，热剧更新与综艺新期同步追踪
            </p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <div className="flex rounded-full border border-background-300 bg-background-50 p-1">
            {tabs.map((item) => (
              <button
                key={item.key}
                type="button"
                onClick={() => setTab(item.key)}
                className={`cursor-pointer whitespace-nowrap rounded-full px-3 py-1 text-[11px] font-medium transition-colors md:text-xs ${
                  tab === item.key
                    ? "bg-primary-800 text-background-50"
                    : "text-foreground-600 hover:text-primary-700"
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3.5 sm:grid-cols-3 sm:gap-4 lg:grid-cols-6">
        {list.map((video) => (
          <VideoCard key={video.id} video={video} showTagline={false} />
        ))}
      </div>

      <div className="mt-6 flex justify-center">
        <Link
          to={tab === "all" ? "/category/movie" : `/category/${tab}`}
          className="flex h-10 items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 text-xs font-semibold text-primary-800 transition-colors hover:border-primary-300 hover:bg-primary-50"
        >
          查看更多更新
          <i className="ri-arrow-right-line text-sm" />
        </Link>
      </div>
    </section>
  );
}